/**
 * Helper functions for Collection Funnel calculations
 */

/**
 * Calculate conversion rates from funnel metrics
 */
export function calculateConversionRates(
  collectionViewers: number,
  addersToCart: number,
  purchasers: number,
) {
  const collectionToCartConversion =
    collectionViewers > 0 ? (addersToCart / collectionViewers) * 100 : 0
  const cartToPurchaseConversion =
    addersToCart > 0 ? (purchasers / addersToCart) * 100 : 0
  const collectionToPurchaseConversion =
    collectionViewers > 0 ? (purchasers / collectionViewers) * 100 : 0

  return {
    collectionToCartConversion,
    cartToPurchaseConversion,
    collectionToPurchaseConversion,
    collectionToCartAbandon: 100 - collectionToCartConversion,
    cartToPurchaseAbandon: 100 - cartToPurchaseConversion,
    collectionToPurchaseAbandon: 100 - collectionToPurchaseConversion,
  }
}
